import Button from 'tailwind-components/Button/Button';
import React from 'react';
import propTypes from 'prop-types';
import style from './sendEmailConfirmationForm.module.scss';
import { useDispatch } from 'react-redux';
import { sanitizeDirtyHTML } from 'helpers/strings';

function SendEmailConfirmationForm({
  closeModal,
  modalText,
  dispatchFunction
}) {
  const dispatch = useDispatch();
  const onConfirm = () => {
    closeModal();
    dispatch(dispatchFunction());
  };

  if (!modalText) return null;

  return (
    <div className={style.sendEmail}>
      <div dangerouslySetInnerHTML={sanitizeDirtyHTML(modalText)}></div>
      <Button onClick={onConfirm} text='Send' fill variant='primary' />
    </div>
  );
}

SendEmailConfirmationForm.propTypes = {
  closeModal: propTypes.func,
  modalText: propTypes.string,
  dispatchFunction: propTypes.func
};

export default SendEmailConfirmationForm;
